"use client";

import { useEffect, useRef } from "react";
import { track } from "./track";
import type { AnalyticsEventName, AnalyticsEventPayloads } from "./events";

/**
 * Vuurt één keer per paginabezoek een event af. Voor events die geen klik zijn
 * maar een weergave: een case die geopend wordt, een route die in beeld komt.
 * Zet hem in een serverpagina; het component rendert niets.
 */
export function TrackView<K extends AnalyticsEventName>({
  event,
  payload,
}: {
  event: K;
  payload: AnalyticsEventPayloads[K];
}) {
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    track(event, payload);
    // De payload hoort bij deze pagina; opnieuw vuren bij een re-render niet.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
